module.exports = __webpack_public_path__ + "static/img/promo_order_3 - Copy.dcb5d37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promo_order_3 - Copy.jpg
// module id = hBcI
// module chunks = 0